<script setup>
defineProps({ compact: { type: Boolean, default: false } });
const label = 'Super Admin Console';
</script>

<template>
  <a
    v-tooltip="label"
    href="/super_admin"
    target="_blank"
    rel="noopener noreferrer"
    :aria-label="label"
    class="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-brand focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
    :class="compact ? 'size-10' : 'w-full justify-start px-3 py-2 text-sm'"
  >
    <span class="i-hugeicons-user-shield-01 size-5 shrink-0" />
    <span v-if="!compact">{{ label }}</span>
  </a>
</template>
